import { Component, computed, signal } from '@angular/core';
import { delay } from '@gametailors/web-core/misc';

@Component({
  selector: 'rid-reading-countdown',
  imports: [],
  templateUrl: './rid-reading-countdown.html',
  host: {
    class: 'block absolute top-[50%] -left-4 -translate-x-[100%] -translate-y-[50%]',
    'animate.enter': 'anim-fade-from-right',
    'animate.leave': 'anim-pop-out',
  },
})
export class RidReadingCountdown {
  steps = signal(2);
  index = signal<undefined | number>(undefined);

  _steps = computed(() => Array.from({ length: this.steps() }, (_, i) => i));

  async countdown(interval: number) {
    for (let i = 0; i < this.steps(); i++) {
      this.index.set(i);
      await delay(interval);
    }

    this.index.set(undefined);
  }
}
